import React from 'react';
import { Ads, inlineDefineAd } from './Ad';

export interface AdSetupProps {
  /** Any ad definitions to setup to be requested as part of the initial ad request. */
  predefineAds?: Ads;
  pageLevelTargeting?: { key: string, value: string | string[] }[];
}

/** Sets up a view to display ads. */
const AdSetup = ({ 
  predefineAds = {},
  pageLevelTargeting = [] 
}: AdSetupProps) => {
  // console.log('AdSetup', predefineAds);
  if (process.env.TESTING === 'true') {
    return <></>;
  }
  return (
    <script
      data-cfasync={'false'}
      dangerouslySetInnerHTML={{
        __html: `
    window.googletag = window.googletag || {cmd: []};
    window.localStorage.setItem('sas_page-level-targeting', '${JSON.stringify(pageLevelTargeting)}');
    window.localStorage.setItem('sas_predefine-ads', '${JSON.stringify(predefineAds)}');
    
    googletag.cmd.push(function() {
      if (window.STARLORD_ADS_SETUP) return;
      var uuid = window.localStorage.getItem('sas_uuid');
      if (uuid) {
        googletag
          .pubads()
          .setPublisherProvidedId(uuid);
      }

      //  Page level googletag targeting
      ${pageLevelTargeting.reduce(
        (result, { key, value }) => {
          // Emit array values as a JS array literal so GAM receives discrete,
          // targetable values — e.g. setTargeting('categories', ["health","news"])
          // — rather than one comma-joined string. Strings pass through quoted.
          return `googletag.pubads().setTargeting('${key}', ${JSON.stringify(value)});\n${result}`;
        },
        ''
      )}
      
      ${Object.keys(predefineAds).reduce((result, key) => `${inlineDefineAd(predefineAds[key])}\n${result}`, '')}

      googletag.pubads();
      googletag.pubads().setCentering(true);
      googletag.pubads().collapseEmptyDivs();
      googletag.enableServices();
      window.STARLORD_ADS_SETUP = true;
    });
  `,
      }}
    />
  );
};

export default AdSetup;
